/**
 * Filter state for the Team popover (Figma 2325:125856).
 *
 * Both dropdowns are single-select plain lists — no checkboxes, no search, no
 * "Add New" — unlike the Menu filter's checkbox facets.
 *
 * ⚠️ **The option lists used to live here, hardcoded from the design. They are
 * gone.** `staff/form-options/` publishes both, and two things made the local
 * copy actively wrong rather than merely duplicated:
 *
 * · **The filter submits identifiers, not labels.** `?department=` takes the
 *   slug (`front_of_house`) and `?job_title=` takes the role's **uuid** — a
 *   display name is a 400 on both. The old lists stored labels, so every filter
 *   they produced would have been refused.
 * · **Job titles are seeded per tenant** and this API has no route to list
 *   them; `form-options/` `roles[]` is the only source. A hardcoded three would
 *   have been wrong for any venue with a different set.
 *
 * The page fetches them and passes them to `TeamFilterPopover`.
 */

/**
 * Committed filter selections. Empty string means "no filter".
 *
 * Both values are **API identifiers**: `department` is a slug, `jobTitle` is a
 * uuid. `TeamQuerySync` writes them straight into the URL, so they must never
 * hold a display label.
 */
export interface TeamFilters {
  department: string;
  jobTitle: string;
}

export const EMPTY_TEAM_FILTERS: TeamFilters = {
  department: "",
  jobTitle: "",
};
